import React from 'react';
import defaultStyles from "../../../styles/main.module.css"
const StandardTextInput = ({
                               value,
                               onChange,
                               placeholder = '',
                               styles,
                               isDisabled = false,
                               handleBeforeInput = null,
                               forceLowercase = false
                           }) => {
    const handleChange = (e) => {
        console.log(`forcing lower case`)
        const inputValue = e.target.value;
        onChange(forceLowercase ? inputValue.toLowerCase() : inputValue);
    };

    return (
        <input
            className={defaultStyles.standardTextField}
            onBeforeInput={handleBeforeInput}
            type='text'
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={isDisabled}
            style={styles}
        />
    );
};


export default StandardTextInput;
